import { Component, Input } from '@angular/core';
import { IAvaluoFiscal, IVivienda } from 'src/app/models/contribuciones/avaluo-fiscal.model';
import { PdfGeneratorService } from 'src/app/shared/services/pdf-generator.service';
import { AlertService } from '../../_alert/alert.service';
import { goToTop } from 'src/app/shared/utils/utils';

@Component({
    selector: 'app-avaluo-fiscal-viewer',
    templateUrl: './avaluo-fiscal-viewer.component.html',
    styleUrls: ['./avaluo-fiscal-viewer.component.scss']
})
export class AvaluoFiscalViewerComponent {
    @Input() content!: IAvaluoFiscal;
    @Input() rut!: string;
    @Input() showHeader = true;

    private idTransaccion!: string;
    public today = '';

    public viviendas: IVivienda[] = [];
    public numPropiedades?: number;
    public totalAvaluos?: number;

    public bienesComunesDisplayedColumns: string[] = [
        'rol',
        'tipoCopropiedad',
        'total',
        'prorrateoPorcentual',
        'avaluoProrrateado',
    ];

    public lineasTerrenoDisplayedColumns: string[] = [
        'linea',
        'superficie',
        'avaluoUnitario',
        'avaluoLinea',
    ];

    public lineasConstruccionDisplayedColumns: string[] = [
        'linea',
        'clase',
        'calidad',
        'cantidad',
        'anioConstruccion',
        'avaluoLinea',
    ];

    isPDFLoading = false;
    PDF_REPORT_NAME = 'avaluoFiscal';

    constructor(
        private pdfGeneratorService: PdfGeneratorService,
        private alertService: AlertService,
    ) {}

    ngOnInit(): void {
        this.setToday();
        this.viviendas = this.content.Reporte.viviendas;
        this.setNumPropiedades();
        this.setTotalAvaluos();

        this.idTransaccion = this.content.DatosBasicosSolicitud.IDTransaccion;
    }

    setToday() {
        this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) :
            new Date().getMonth() + 1)}${new Date().getDate()}`;
    }

    setNumPropiedades() {
        this.numPropiedades = this.viviendas.length;
    }

    setTotalAvaluos() {
        this.totalAvaluos = this.viviendas.reduce((total, vivienda) => {
            return total + vivienda.certificado.price.total;
        }, 0);
    }

    getPDF() {
        this.isPDFLoading = true;
        this.pdfGeneratorService._getPDF(this.idTransaccion, this.PDF_REPORT_NAME).subscribe(
            response => {
                if (response.URLReporte) {
                    window.open(response.URLReporte, '_blank');
                }
                this.isPDFLoading = false;
            },
            ({error}) => {
                this.alertService.error(`Error al obtener el PDF: ${error?.message}`);
                goToTop();

                this.isPDFLoading = false;
            }
        )
    }

    generatePDF() {
        this.isPDFLoading = true;
        this.pdfGeneratorService._generatePDF(this.idTransaccion, this.PDF_REPORT_NAME, '', '', this.rut).subscribe(
            () => {
                this.getPDF();
            },
            ({error}) => {
                this.alertService.error(`Error al generar el PDF: ${error?.message}`);
                goToTop();

                this.isPDFLoading = false;
            }
        )
    }

}
